import script from "./AvatarSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarSelect.vue?vue&type=script&setup=true&lang=js"

import "./AvatarSelect.vue?vue&type=style&index=0&id=7a809765&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a809765"]])

export default __exports__